import { connect, mapProps } from '@formily/react';
import { CnInput as UiInput } from "../../components/cn-input";
import { mapSize, mapStatus } from "../__builtins__";
export var CnInput = connect(UiInput, mapProps(mapSize, mapStatus));
CnInput.displayName = 'CnInput';
